export default __webpack_public_path__ + "static/media/audiobook-in-a-card-big.426b402e.png";